import React from 'react';

import theme from '../utils/theme';
import styled from '@emotion/styled';
import { tabletQuery, desktopQuery } from '../utils/mediaqueries';

import Link from './Link';
import { GatsbyImage } from 'gatsby-plugin-image';

const LayoutWrapper = styled.div(
  {
    display: 'flex',
    textDecoration: 'none',
    borderBottom: `1px solid ${theme.colors.blue}`,
    height: '198px',
    transition: 'background 500ms',

    '&:hover': {
      background: theme.colors.blue,
    },
  },
  ({ highlight }) => ({
    background: highlight ? theme.colors.lightBlue : theme.colors.darkBlue,
  }),
);

const LayoutWithNavLink = LayoutWrapper.withComponent(Link);

const TextWrapper = styled.div({
  margin: '20px 0 20px 20px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  color: theme.colors.mainText,
});

const ImageWrapper = styled.div({
  height: '80%',
  marginLeft: 'auto',
});

const StyledHeading = styled.h2({
  fontSize: '1.0625rem',
  margin: 0,
  marginBottom: '15px',

  [tabletQuery]: {
    fontSize: '1.5625rem',
  },

  [desktopQuery]: {
    fontSize: '1.3rem',
  },
});

const Description = styled.p({
  textAlign: 'left',
  color: theme.colors.descriptionText,

  [tabletQuery]: {
    fontSize: '1.25rem',
  },

  [desktopQuery]: {
    fontSize: '1.3rem',
  },
});

const NavExcerpt = ({ currentUrl, description, heading, id, onClick, state, thumbnail, to }) => {
  const { gatsbyImageData } = thumbnail.childImageSharp;
  const isUrlSame = currentUrl === to;
  const thumbnailStyles = {
    borderRadius: '5px',
    margin: '20px',
    height: '100%',
    width: '107px',
  };

  return (
    <LayoutWithNavLink disabled={isUrlSame} highlight={isUrlSame} id={id} state={state} to={to} onClick={onClick}>
      <TextWrapper>
        <StyledHeading>{heading.toUpperCase()}</StyledHeading>
        <Description>{description}</Description>
      </TextWrapper>
      <ImageWrapper>
        <GatsbyImage image={gatsbyImageData} alt={thumbnail} style={thumbnailStyles} />
      </ImageWrapper>
    </LayoutWithNavLink>
  );
};

export default NavExcerpt;
